import BreadcrumbRanking from "./BreadcrumbRanking"
import { useState, useEffect } from "react";
import { Row, Col, Form, InputGroup, Button, Alert } from "react-bootstrap";
import { formatNumber } from "../../utils/NumberUtils";
import { getRankingClientes } from "../../services/RankingService";
import MaoTable from "../common/MaoTable";
import { useNavigate } from "react-router-dom";
import { getFechaHoy, getFechaInicioMes } from "../../utils/DateUtils";
import RankingClientesChart from "./RankingClientesChart";

export default function RankingClientes() {

    const [fechaDesde, setFechaDesde] = useState(getFechaInicioMes());
    const [fechaHasta, setFechaHasta] = useState(getFechaHoy);

    const [error, setError] = useState('');

    const [ranking, setRanking] = useState([]);
    const [totales, setTotales] = useState({});

    const navigate = useNavigate();

    useEffect(() => {
        buscar();
    }, [])

    // Función para manejar el cambio de la fecha "desde"
    const handleFechaDesdeChange = (e) => {
        setFechaDesde(e.target.value);
    };

    // Función para manejar el cambio de la fecha "hasta"
    const handleFechaHastaChange = (e) => {
        setFechaHasta(e.target.value);
    };

    async function buscar ()  {
        let fechaDesde = document.getElementById('fechaDesde').value
        let fechaHasta = document.getElementById('fechaHasta').value
        let resp = await getRankingClientes(fechaDesde, fechaHasta);
        if (resp.error) {
            setError(resp.message);
            setRanking([]);
        } else {
            setError("")
            setRanking(resp.data);
            let total_ventas = 0;
            let total_comisiones = 0;
            let total_clientes_activos = 0;
            for (let i=0; i<resp.data.length; i++) {
                total_ventas += parseFloat(resp.data[i].ventas);
                total_comisiones += parseFloat(resp.data[i].comisiones);
                total_clientes_activos += parseInt(resp.data[i].clientes_activos);
            }
            setTotales({
                marca: "Total",
                ventas: formatNumber(total_ventas),
                comisiones: formatNumber(total_comisiones),
                clientes_activos: total_clientes_activos
            })
        }
    }

    function volver () {
        navigate("/ranking");
    }

    const columnas = [
        {
            titulo:"Cliente",
            atributo:"cliente",
            className:"text-truncate"
        },{
            titulo:"Ventas",
            atributo:"ventas",
            className:"text-truncate max-width-20-em col-importe",
            funcion: formatNumber
        }
    ]
    
    const dynamicHeight = `${ranking.length * 50}px`;
    return <>
        <BreadcrumbRanking active="Clientes" />
        <Form >
        <Row className="d-flex align-items-center">
          <Col xs="auto" md="3">
            <InputGroup className="mb-2">
              <InputGroup.Text className="btn btn-secondary" style={{width: 5+'em'}}>Desde</InputGroup.Text>
              <Form.Control 
                type="date" 
                id="fechaDesde" 
                value={fechaDesde} 
                onChange={handleFechaDesdeChange}
                placeholder="Fecha Desde..."
              />
            </InputGroup>
          </Col>
          <Col xs="auto" md="3">
            <InputGroup className="mb-2">
              <InputGroup.Text className="btn btn-secondary" style={{width: 5+'em'}}>Hasta</InputGroup.Text>
              <Form.Control 
                type="date" 
                id="fechaHasta"
                value={fechaHasta} 
                onChange={handleFechaHastaChange}
                placeholder="Fecha Hasta..."
              />
            </InputGroup>
          </Col>
          <Col xs="auto" sm="3" md="3">
            <InputGroup className="mb-2">
              <Button onClick={buscar}>Buscar</Button>
            </InputGroup>
          </Col>
        </Row>
        {error!==''?
            <Row>
                <Col xs="auto">
                    <Alert variant="danger" key="danger">{error}</Alert>
                </Col>
            </Row>:
            <></>
        }
      </Form>
      <Row>
        <Col md="6" xs="12">
        <MaoTable 
            columnas={columnas}
            datos={ranking}
            colId="cliente_id"
            totales={totales}
        />
        </Col>
          <Col md="6" xs="12">
            <RankingClientesChart ranking={ranking} />
          </Col>
      </Row>
      <div className="d-flex justify-content-center" style={{marginTop:1+'em'}}>
        <Button onClick={volver}>Volver</Button>
      </div>
    </>

}